module.exports = __webpack_public_path__ + "ch.75db5a41a8901010d10b.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ch.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ch.svg
// module chunks = styles